export const contentPadding = (value: number) => {
  return {
    padding: value,
    "&:last-child": {
      paddingBottom: value
    }
  };
};
